/**
 * 最大可成交人数
 */
export const MAX_DEAL_COUNT = 6
